import LightCard from "../../../../../../components/card/LightCard";
import React from "react";
import {EditButtonStyle, IconStyle} from "../../../../../../components/ui/EditButton";
import {useTranslation} from "react-i18next";
import {Colors} from "../../../../../../components/theme";

const BusinesDataDetails = ({data, setEdit, setPrinting, addClass, children}) => {
    const {t} = useTranslation()

    const clickHandler = () => {
        if (typeof setPrinting === 'function') {
            setEdit(true)
            setPrinting(true)
        } else setEdit(true)
    }

    return (<>
        <div className={"col-xl-6 col-xxl-4 mb-4 " + addClass}>
            <LightCard>
                <div className="px-2">
                    <h3 className="mt-0">
                        {data.name}
                    </h3>
                </div>

                {children}

                <div className="text-end mt-4">
                    <EditButtonStyle className="editBtn" onClick={clickHandler}>
                        <lord-icon
                            src='https://cdn.lordicon.com/hnvrjtda.json'
                            trigger='hover'
                            target='.editBtn'
                            colors={`primary:${Colors.mediumBG},secondary:${Colors.mediumBG}`}
                            style={IconStyle}
                        >
                        </lord-icon>
                        {t("common.button.edit")}
                    </EditButtonStyle>
                </div>
                
            </LightCard>
        </div>
    </>)

}

export default BusinesDataDetails



